import React, { useEffect, useState } from 'react';
import { Box, Heading, Table, Thead, Tbody, Tr, Th, Td, useToast } from '@chakra-ui/react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const base_url = process.env.REACT_APP_API_URL_ADMIN;

const DrawTicketDetails = () => {
  const location = useLocation();
  const toast = useToast();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const drawId = query.get('drawId');
    const userID = query.get('UserID');
    const startDate = query.get('FDate');
    const endDate = query.get('TDate');

    if (!drawId) {
      setError('Invalid draw id');
      setLoading(false);
      return;
    }

    const fetchTickets = async () => {
      try {
        const res = await axios.post(`${base_url}`, {
          apiName: 'ticket',
          command: 'getTicketsByDraw_id',
          draw_id: drawId,
          userID,
          startDate,
          endDate,
        });
        setTickets(res.data.data || []);
      } catch (err) {
        const msg = err.response?.data?.message || 'Failed to fetch tickets';
        setError(msg);
        toast({ title: 'Error', description: msg, status: 'error', duration: 5000, isClosable: true });
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, [location.search, toast]);

  if (loading) return <Box>Loading...</Box>;
  if (error) return <Box>Error: {error}</Box>;

  const drawId = new URLSearchParams(location.search).get('drawId');

  return (
    <Box>
      <Heading mb={4}>Tickets for Draw {drawId}</Heading>
      <Table variant="striped" size="sm">
        <Thead>
          <Tr>
            <Th>Ticket ID</Th>
            <Th>Draw ID</Th>
            <Th>Total Points</Th>
            <Th>Win Points</Th>
            <Th>Status</Th>
            <Th>Entry Time</Th>
          </Tr>
        </Thead>
        <Tbody>
          {tickets.map((t, idx) => (
            <Tr key={idx}>
              <Td>{t.ticket_id}</Td>
              <Td>{t.draw_id}</Td>
              <Td>{t.total_points}</Td>
              <Td>{t.win_points}</Td>
              <Td>{t.status}</Td>
              <Td>{t.entry_time ? new Date(t.entry_time).toLocaleString() : ''}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default DrawTicketDetails;
